module.exports = __webpack_public_path__ + "img/3.458f02fd.png";